import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SDTKService } from '../sdtk.service';
import { formatDate } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { QuoteService } from '../../quote.service';
import { environment } from '../../../../environments/environment';
import { LocalStorageService } from 'ngx-webstorage';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SDTK } from '../../../model/quote/sdtk/sdtk.model';

@Component({
  selector: 'app-sdtk-quotation',
  templateUrl: './sdtk-quotation.component.html',
  styleUrls: ['./sdtk-quotation.component.css', '../../quote.component.css']
})
export class SdtkQuotationComponent implements OnInit, OnChanges, AfterViewChecked {

  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private sdtkService: SDTKService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private quoteService: QuoteService,
    private sessionSt: LocalStorageService,
    private _snackBar: MatSnackBar) {
  }

  get f(): { [key: string]: AbstractControl } {
    return this.formFields.controls;
  }

  formFields: any;
  submitted = false;

  helptext = '';

  parentModelObject: { [p: string]: any };
  coverPeriod: string;
  reference: any;
  proposerType: string;
  isReferred = false;
  buttonText: string;
  attentionRequiredText: string;
  documents: any = [];
  premium_excl_ipt = 0;
  premium_incl_ipt = 0;
  ipt_value = 0;
  store_location_exists: boolean = false;
  loading_charges: number = 0;
  quote_type: number = this.route.snapshot.params.quote_type;
  @Input() authDetails: any;
  @Input() staticData: any;
  @Input() excessProtectOptions: any;
  @Input() selectedIndex: number;
  @Input() modelObject;
  @Input() apiModelObject: {
    type: number;
    sequence_number: any;
    quote_ref_number: any;
    company_id: any;
    financial_details: { broker_admin_fee: any; breakdown_gross: any; ipt_value: any; total_policy_cost: any; };
    policy_start_date: any;
    excess_protect_cover_id: any;
    id: any;
    sdtk_questions: [];
  };
  @Output() modelObjectUpdated = new EventEmitter<SDTK>();
  @Output() back = new EventEmitter<any>();

  // Currently selected cover ID
  selectedCoverId: string = '';

  // The currently selected premium object (will be used in template)
  selectedPremium: any = null;

  // isBroker = this.sessionSt.retrieve("is_broker");
  referAndExit = false;

  ipt = 0;
  gross = 0; // Principal Amount
  totalPremIncIpt = 0; // Principal Amount
  totalAmount = 0;
  vehiclePremiumsKey = '';
  vehiclePremiumsValue = 0;
  grossPremium = 0;
  premiums: any = '{"referred": null,"ipt": 0,"gross": 0,"breakdown_ipt": 0,"breakdown_gross": 0,"total_amount": 0,"gross_premium":0,"vehicle_premiums": {},"breakdown_premiums": {},"vehicle_excesses": {},"driver_excesses": [ ],"compulsory_excess": 0}';
  breakdownPremiumsArr = [];
  calErrors: any = [];
  hasErrors = false;
  peliwica_fee: number;

  isAdmin = false;
  isStaff = false;
  isBroker = false;
  rating_amount;

  ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
    if (this.sessionSt.retrieve('is_staff')) {
      this.isStaff = true;
    }
    if (this.sessionSt.retrieve('is_broker')) {
      this.isBroker = true;
    }

    this.formFields = this.formBuilder.group({
      breakdown_cover: [''],
      registered_owner: [''],
      commission: ['20', Validators.required],
      broker_admin_fee: ['0', Validators.required],
      discount: ['0', Validators.required],
      refer_reason: ['', Validators.required],
      excess_protect_cover_id: ['', Validators.required]
    });

  }


  ngOnChanges(changes: SimpleChanges) {
    console.log("Quotation Page");
    console.log(this.selectedIndex);
    if (this.apiModelObject) {
      this.modelObject = this.mapApiToSDTK(this.apiModelObject);

      this.premium_excl_ipt = this.apiModelObject.financial_details.breakdown_gross;
      this.premium_incl_ipt = this.apiModelObject.financial_details.total_policy_cost;
      this.ipt_value = this.apiModelObject.financial_details.ipt_value;
      this.modelObject.type = this.apiModelObject.type;
      this.modelObject.sequenceNumber = this.apiModelObject.sequence_number;
      this.modelObject.company_id = this.apiModelObject.company_id;
      this.modelObject.brokerAdminFee = this.apiModelObject.financial_details.broker_admin_fee;
      this.selectedCoverId = this.modelObject.excess_protect_cover_id;
      this.reference = this.apiModelObject.quote_ref_number;
      this.modelObject.sdtk_option_id = this.modelObject.sdtk_option_id;

      const maxDate = new Date(this.apiModelObject.policy_start_date).setFullYear(new Date(this.apiModelObject.policy_start_date).getFullYear() + 1);
      const newDate = new Date(new Date(maxDate).getTime() - (24 * 60 * 60 * 1000));
      this.coverPeriod = formatDate(this.apiModelObject.policy_start_date, 'dd-MM-yyyy', 'en-US') + ' to ' + formatDate(newDate, 'dd-MM-yyyy', 'en-US');
      this.getDocuments(this.apiModelObject.id);
      this.getOptionRate(this.modelObject.sdtk_option_id);
      //this.updateSelectedPremium();
      if (this.modelObject.questions && (this.modelObject.questions.storage_location != 1)) {
        this.store_location_exists = true;
        this.loading_charges = this.premium_incl_ipt * 25 / 100;
      }

      this.patchValues();
    }
    else {
      if (this.modelObject.questions && this.modelObject.questions.storage_location != 1) {
        this.store_location_exists = true;
        this.loading_charges = this.premium_incl_ipt * 25 / 100;
      }
      this.reference = this.modelObject.reference != null ? this.modelObject.reference : "";
      this.premium_excl_ipt = this.modelObject.breakdown_gross != null ? this.modelObject.breakdown_gross : "";
      this.ipt_value = this.modelObject.ipt_value != null ? this.modelObject.ipt_value : "";
      this.premium_incl_ipt = this.modelObject.total_policy_cost != null ? this.modelObject.total_policy_cost : "";
      if (this.modelObject.inception_date != "") {
        const maxDate = new Date(this.modelObject.inception_date).setFullYear(new Date(this.modelObject.inception_date).getFullYear() + 1);
        const newDate = new Date(new Date(maxDate).getTime() - (24 * 60 * 60 * 1000));
        this.coverPeriod = formatDate(this.modelObject.inception_date, 'dd-MM-yyyy', 'en-US') + ' to ' + formatDate(newDate, 'dd-MM-yyyy', 'en-US');
        this.getDocuments(this.modelObject.id);
      }

      if (this.modelObject.sdtk_option_id != null) {
        this.getOptionRate(this.modelObject.sdtk_option_id);
      }


    }



    if (this.selectedIndex >= 3) {
      let inceptionDate: string | number | Date;
      if (this.modelObject.data) {
        this.parentModelObject = this.modelObject.data;
        inceptionDate = this.parentModelObject.attributes.application.inceptionDate;
        this.reference = this.modelObject.reference;
        this.proposerType = this.parentModelObject.attributes.application.proposer.proposer_type;
        if (this.parentModelObject.attributes.premium && this.parentModelObject.attributes.premium.referred) {
          this.isReferred = true;
        }

      } else {
        this.parentModelObject = this.modelObject;
        inceptionDate = this.modelObject.inception_date;
        if (this.apiModelObject) {
          console.log(this.apiModelObject);
          //this.reference = this.apiModelObject.data.quote_ref_number;
        } else {
          this.reference = this.modelObject.reference;
          if (this.modelObject.isReferred) {
            this.isReferred = true;
          }
        }
        this.proposerType = this.modelObject.proposer.proposer_type;
      }

      const maxDate = new Date(inceptionDate).setFullYear(new Date(inceptionDate).getFullYear() + 1);
      const newDate = new Date(new Date(maxDate).getTime() - (24 * 60 * 60 * 1000));
      this.coverPeriod = formatDate(inceptionDate, 'dd-MM-yyyy', 'en-US') + ' to ' + formatDate(newDate, 'dd-MM-yyyy', 'en-US');

      this.getPeliwicaPremium();

      this.formFields.get('broker_admin_fee').setValue(this.modelObject.brokerAdminFee);

    }
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  patchValues() {
    this.formFields.patchValue({
      voluntary_excess: this.modelObject.voluntaryExcess,
      commission: 20, // this.modelObject.commission
      broker_admin_fee: this.modelObject.brokerAdminFee,
      discount: (this.modelObject.discount > 0) ? this.modelObject.discount : 0,
      excess_protect_cover_id: this.modelObject.excess_protect_cover_id
    });

    if (this.modelObject.vehicles && this.modelObject.vehicles.length > 0) {
      this.modelObject.vehicles.forEach((res) => {
        // tslint:disable-next-line:no-unused-expression
        res.own;
      });
    }

  }

  /*
 * HELP TEXT POPUP
 */
  helpTextPopup(content, text) {
    this.modalService.open(content, { centered: true });
    this.helptext = text;
  }

  /*
  * Calculate Premium
  */
  calculatePremium() {
    this.calErrors = [];
    this.bindPostData();
    let data;
    let obj = this.modelObject;
    if (this.modelObject.data) {
      obj = this.modelObject.data.attributes.application;
    }
    if (this.apiModelObject && this.apiModelObject.type !== 3) {
      obj.policyId = '';
      obj.effectiveDate = '';
    }

    obj.voluntaryExcess = this.f.voluntary_excess.value;
    data = {
      data: {
        type: 'breakdown/quote',
        attributes: obj
      }

    };


    this.sdtkService.calculatePremium(data)
      .subscribe(
        (res: any) => {
          if (res.meta) {
            this.hasErrors = false;
            this.isReferred = res.meta.referred;
            if (res.meta.referred) {
              this.calErrors = [];
              const msg = { detail: 'Your quote has referred, clicking save and exit will send your quote to the underwriter for review' };
              this.calErrors.push(msg);
              this.buttonText = 'Save & Refer to Underwriter';
              this.attentionRequiredText = 'This quote needs to be referred, please click ‘Save & Refer to Underwriter’ to proceed.';
            } else {
              this.calErrors = [];
              this.buttonText = 'Save & Exit';
              this.attentionRequiredText = '';
            }

            if (res.meta.vehicle_premiums) {
              this.vehiclePremiumsKey = Object.keys(res.meta.vehicle_premiums)[0];
              this.vehiclePremiumsValue = Number(Object.values(res.meta.vehicle_premiums)[0]);
              this.grossPremium = Number(res.meta.gross);
              this.totalPremIncIpt = Number(res.meta.gross) + Number(res.meta.breakdown_gross);
              // this.gross_premium = Number(Object.values(res.meta.vehicle_premiums)[0]) + Number(res.meta.ipt);
            }
            const brokerAdminFee = (this.modelObject) ? this.modelObject.brokerAdminFee : 0;
            this.formFields.get('broker_admin_fee').setValue(brokerAdminFee);

            if (this.modelObject && this.modelObject.isSendEmail === 1) {
              this.totalAmount = this.grossPremium + Number(brokerAdminFee) + Number(res.meta.breakdown_gross);
            } else {
              this.totalAmount = this.grossPremium + Number(res.meta.breakdown_gross);
            }
            // this.total_amount = this.gross_premium + Number(this.peliwica_fee) + Number(res.meta.breakdown_gross);
            this.premiums = res.meta;
            this.breakdownPremiumsArr = [];
            if (res.meta.breakdown_premiums) {
              if (res.meta.breakdown_premiums instanceof Array) {
                res.meta.breakdown_premiums.forEach((res) => {
                  const breakdown = {
                    registration_number: '',
                    value: 0,
                    is_checked: false
                  };
                  // breakdown[Object.keys(res.meta.breakdown_premiums)[0]] = Number(Object.values(res.meta.breakdown_premiums)[0]);
                  breakdown.registration_number = Object.keys(res.meta.breakdown_premiums)[0];
                  breakdown.value = Number(Object.values(res.meta.breakdown_premiums)[0]);

                  this.breakdownPremiumsArr.push(breakdown);
                });
              } else {
                const breakdown = {
                  registration_number: '',
                  value: 0,
                  is_checked: false
                };
                breakdown.registration_number = Object.keys(res.meta.breakdown_premiums)[0];
                breakdown.value = Number(Object.values(res.meta.breakdown_premiums)[0]);
                this.breakdownPremiumsArr.push(breakdown);

              }


              this.breakdownPremiumsArr.forEach((res) => {
                this.modelObject.vehicles.forEach((res1) => {
                  if (res1.registration_number === res.registration_number) {
                    res.is_checked = res1.breakdown_cover;
                  }
                });
              });
            }
          }
        },
        err => {
          this.hasErrors = true;
          this.calErrors = [];
          if (err.error && err.error.errors) {

            this.calErrors = [];
            const msg = { detail: 'Your quote has referred, clicking save and exit will send your quote to the underwriter for review' };
            this.calErrors.push(msg);
            this.buttonText = 'Save & Refer to Underwriter';
            this.attentionRequiredText = 'This quote needs to be referred, please click ‘Save & Refer to Underwriter’ to proceed.';
          }
          this.premiums = {
            referred: null,
            ipt: 0,
            gross: 0,
            breakdown_ipt: 0,
            breakdown_gross: 0,
            total_amount: 0,
            gross_premium: 0,
            vehicle_premiums: {},
            breakdown_premiums: {},
            vehicle_excesses: {},
            driver_excesses: [],
            compulsory_excess: 0
          };

        },);
  }

  getPeliwicaPremium() {
    this.quoteService.getLiveStockBrokerCommission(this.modelObject.company_id, environment.AMLINE_ID)
      .subscribe(
        (response: any) => {
          if (response.success) {
            if (this.modelObject.type == 3) {
              this.peliwica_fee = 0;
              this.formFields.get('peliwica_fee').setValue(0);
            } else {
              this.peliwica_fee = response.result.uw_fee;
              this.formFields.get('peliwica_fee').setValue(response.result.uw_fee);
            }
          }
          this.calculatePremium();
        },
        (error) => {
          ;
        }
      );
  }

  /*
  * Bind Breakdown Selection
  */
  onBreakdownSelection(event, vehicle_number) {
    this.modelObject.vehicles.forEach((res) => {
      if (res.registration_number == vehicle_number) {
        res.breakdown_cover = event.value;
      }
    });
    this.calculatePremium();
  }

  /*
  * Commission Restrict to 20
  */
  onCommissionChange(event) {
    if (Number(event.target.value) > 20) {
      this.formFields.get('commission').setValue(20);
    }
    this.calculatePremium();
  }

  /*
  * Broker Commission change modal value
  */
  onBrokerCommissionChange(event) {
    this.modelObject.brokerAdminFee = event.target.value;
    this.calculatePremium();
  }

  /*
  * Discount Restrict to 10
  */
  onDiscountChange(event) {
    if (Number(event.target.value) > 10) {
      this.formFields.get('discount').setValue(10);
    }
    if (Number(event.target.value) < 0) {
      this.formFields.get('discount').setValue(0);
    }
    this.calculatePremium();
  }

  /*
  * Bind Owner Name
  */
  onOwnerNameChange(event, vehicle_id) {
    this.modelObject.vehicles.forEach((res) => {
      if (res.id == vehicle_id) {
        res.owner_name = event.target.value;
      }
    });
  }

  onReferReasonChange(value: string): void {
    this.formFields.get('refer_reason').disable();
    if (value !== '') {
      this.formFields.get('refer_reason').enable();
    }
  }

  setReferAndExit(val: boolean): void {
    this.referAndExit = val;
  }

  /*
  * Save Quote Details
  */
  onSubmit(content, referral) {
    this.submitted = true;
    this.formFields.get('refer_reason').disable();



    this.saveQuote(content);
  }

  bindPostData() {
    const formData = this.formFields.value;
    this.modelObject.voluntaryExcess = formData.voluntary_excess;
    this.modelObject.commission = 20; // formData.commission;
    this.modelObject.discount = (formData.discount > 0) ? formData.discount : 0;
    this.modelObject.peliwica_fee = formData.peliwica_fee;
  }

  saveQuote(content) {
    if (this.apiModelObject) {
      this.router.navigateByUrl('/sdtk/quote-details/' + this.apiModelObject.id);
    }
    else {
      if (this.rating_amount > 10000) {
        const data = {
          "quote_data": {
            "id": this.modelObject.id,
          }
        }
        this.sdtkService.sendEmaiToPeliwica(data)
          .subscribe(
            (res: any) => {
              if (res.success) {

              } else {
                this._snackBar.open(res.message, '', {
                  duration: 5000,
                  panelClass: 'text-danger'
                });
              }
            },
            (error) => {
              this._snackBar.open('Error saving data. Please try again.', '', {
                duration: 5000,
                panelClass: 'text-danger'
              });
              console.error('Save error:', error);
            }
          );
      }
      this.router.navigateByUrl('/sdtk/quote-details/' + this.modelObject.id);
    }

  }

  private mapApiToSDTK(api: any): SDTK {
    const model = new SDTK();
    if (!api) {
      return model;
    }
    model.id = api.id;
    model.type = api.type;
    model.broker_id = api.broker_id;
    model.company_id = api.company_id;
    model.sequenceNumber = api.sequence_number;
    model.policyRefNumber = api.policy_ref_number;
    model.quoteMetaId = api.quote_meta_id;
    model.sdtk_option_id = api.sdtk_option_id;
    model.excess_protect_cover_id = api.excess_protect_cover_id;

    model.inception_date = api.policy_start_date;
    model.cover_to = api.policy_end_date;
    model.effectiveDate = api.effective_date;

    // proposer
    model.proposer.micro_enterprise = api.policy_holder.is_micro_enterprise;
    model.proposer.first_name = api.policy_holder.first_name;
    model.proposer.last_name = api.policy_holder.last_name;
    model.proposer.title = api.policy_holder.title;
    model.proposer.dob = api.policy_holder.dob;
    model.proposer.email = api.policy_holder.email;
    model.proposer.phone = api.policy_holder.phone;
    model.proposer.is_phone = api.policy_holder.is_phone;
    model.proposer.sms = api.policy_holder.sms;
    model.proposer.post = api.policy_holder.post;
    model.proposer.is_email = api.policy_holder.is_email;
    model.proposer.proposer_type = api.policy_holder.proposer_type;
    model.proposer.micro_enterprise = api.policy_holder.is_micro_enterprise;
    model.proposer.company_name = api.policy_holder.company_name;
    model.proposer.trading_name = api.policy_holder.trading_name;
    model.proposer.year = api.policy_holder.year_of_establishment;
    model.proposer.address.line1 = api.policy_holder.address.address1;
    model.proposer.address.line2 = api.policy_holder.address.address2;
    model.proposer.address.line3 = api.policy_holder.address.address3;
    model.proposer.address.line4 = api.policy_holder.address.address4;
    model.proposer.address.county = api.policy_holder.address.city;
    model.proposer.address.postcode = api.policy_holder.address.postcode;
    model.proposer.address.country = api.policy_holder.address.country;

    model.vehicles = api.vehicles ?? [];
    model.questions = api.sdtk_questions ?? [];

    // financial details
    if (api.financial_details) {
      model.brokerAdminFee = api.financial_details.broker_admin_fee;
      model.brokerComission = api.financial_details.broker_commission;
    }

    return model;
  }

  getDocuments(id) {
    let type = 1;
    this.quoteService.getQuoteDocuments(id, type)
      .subscribe(
        (response: any) => {
          if (response.success) {
            const generatedDocs = response.result.filter(doc => doc.is_static == 0);
            const uniqueDocuments = this.getLatestUniqueDocuments(response.result);
            //const staticDocs = response.result.filter(doc => doc.is_static == 1);
            const staticDocs = response.result;
            //this.rowDataPeliwica = generatedDocs;
            this.documents = uniqueDocuments;
          }
        },
        (error) => {
          ;
        }
      );
  }
  getLatestUniqueDocuments(documents: any[]): any[] {
    // Group documents by a unique identifier (adjust based on your data structure)
    // Assuming documents have an 'id' or 'title' field to identify duplicates
    const documentMap = new Map<string, any>();

    documents.forEach(doc => {
      const key = doc.title || doc.id; // Use title or id as the unique key
      const existing = documentMap.get(key);

      // Keep the document with the latest date/timestamp
      // Adjust the date field name based on your data structure (e.g., 'created_at', 'updated_at', 'timestamp')
      if (!existing || new Date(doc.created_at) > new Date(existing.created_at)) {
        documentMap.set(key, doc);
      }
    });

    return Array.from(documentMap.values());
  }
  downloadDocument(actionType: string, document: any) {
    if (actionType === 'download') {
      this.quoteService.downloadDocs(document);
    }
  }
  getDisplayTitle(title: string): string {
    if (!title) {
      return '';
    }

    const t = title.toUpperCase();

    if (t.includes('QUOTE')) {
      return 'Quote Schedule';
    }

    if (t.includes('POLICY')) {
      return 'Policy Wording';
    }

    if (t.includes('IPID')) {
      return 'IPID';
    }

    return title; // fallback
  }


  goBack() {
    this.back.emit(this.modelObject);
  }
  public getOptionRate(id) {
    this.sdtkService.getSDTKRatinAmount(id)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.rating_amount = Number(response.amount);
            console.log(this.rating_amount);
          }
        },
        (error) => {
          console.error('Error fetching cover limits:', error);
        }
      );
  }
}
